<template>
  <el-dialog title="修改广告" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form :model="editStoreAdsInfo" :rules="rules" ref="editForm" label-width="120px">
      <el-form-item label="广告名称" prop="adName">
        <el-input v-model="editStoreAdsInfo.adName" placeholder="必填，请填写广告名称"></el-input>
      </el-form-item>
      <el-form-item label="广告类型" prop="adTypeCd">
        <el-select v-model="editStoreAdsInfo.adTypeCd" placeholder="必填，请选择广告类型" style="width:100%">
          <el-option v-for="item in editStoreAdsInfo.adTypes" :key="item.statusCd" :label="item.name"
            :value="item.statusCd">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="顺序" prop="seq">
        <el-input v-model="editStoreAdsInfo.seq" placeholder="必填，请填写顺序"></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker v-model="editStoreAdsInfo.startTime" type="datetime" placeholder="必填，请选择开始时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker v-model="editStoreAdsInfo.endTime" type="datetime" placeholder="必填，请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="链接地址" v-if="editStoreAdsInfo.advertType != 3">
        <el-input v-model="editStoreAdsInfo.pageUrl" placeholder="选填，请填写链接地址"></el-input>
      </el-form-item>
      <el-form-item label="广告图片" prop="imgUrl">
        <upload-image-url ref="uploadImage" :imageCount="1" @notifyUploadCoverImage="handleImageUpload">
        </upload-image-url>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="editStoreAds">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMallAd } from '@/api/storeAds/storeAdsApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  components: {
    UploadImageUrl
  },
  data() {
    return {
      dialogVisible: false,
      editStoreAdsInfo: {
        adId: '',
        adName: '',
        adTypeCd: '',
        seq: '',
        startTime: '',
        endTime: '',
        pageUrl: '',
        imgUrl: '',
        adTypes: [],
        shopId: '',
        advertType: ''
      },
      rules: {
        adName: [
          { required: true, message: '广告名称不能为空', trigger: 'blur' },
          { max: 128, message: '广告名称不能超过128位', trigger: 'blur' }
        ],
        adTypeCd: [
          { required: true, message: '广告类型不能为空', trigger: 'change' }
        ],
        seq: [
          { required: true, message: '顺序不能为空', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '顺序必须为正整数', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ],
        imgUrl: [
          { required: true, message: '请上传广告图片', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.getDictData()
      this.$nextTick(() => {
        this.editStoreAdsInfo = { ...row }
        this.$refs.editForm && this.$refs.editForm.clearValidate()
        this.$refs.uploadImage && this.$refs.uploadImage.setImages([row.imgUrl])
      })
    },
    async getDictData() {
      try {
        const { data } = await getDict('store_ads', 'ad_type')
        this.editStoreAdsInfo.adTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleImageUpload(photos) {
      if (photos && photos.length > 0) {
        this.editStoreAdsInfo.imgUrl = photos[0]
      } else {
        this.editStoreAdsInfo.imgUrl = ''
      }
    },
    async editStoreAds() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          let shopId = getShopId()
          this.editStoreAdsInfo.shopId = shopId
          try {
            const res = await updateMallAd(this.editStoreAdsInfo)
            if (res.code === 0) {
              this.$message.success('修改成功')
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg)
            }
          } catch (error) {
            console.error('请求失败:', error)
          }
        }
      })
    },
    handleClose() {
      this.editStoreAdsInfo = {
        adId: '',
        adName: '',
        adTypeCd: '',
        seq: '',
        startTime: '',
        endTime: '',
        pageUrl: '',
        imgUrl: '',
        adTypes: [],
        shopId: '',
        advertType: ''
      }
    }
  }
}
</script>